import React from 'react';

export default class Overlay extends React.Component {
    render() {
        return <div className={this.props.active ? "overlay active" : "overlay"}></div>
    }
}


// WEBPACK FOOTER //
// ./src/components/Presentation/Overlay.js